// Watch the signed-in club's platform account record (status + clubId). This is
// a GLOBAL node (/platformAccounts/{uid}), not tenant-scoped — plain ref(db,…).
import { ref, onValue } from 'firebase/database'
import { db } from './firebase.js'

export const ACTIVE_SUB = new Set(['active', 'trialing'])
export function isActive(account) { return !!account && ACTIVE_SUB.has(account.status) }

export function watchAccount(uid, cb) {
  if (!uid) { cb(null); return () => {} }
  return onValue(ref(db, `platformAccounts/${uid}`), (snap) => cb(snap.val()), () => cb(null))
}
